import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Task } from '../protogen/planning/service_pb';
import { TaskStateMappings } from '../task-states';

@Component({
  selector: 'app-edit-task-form',
  templateUrl: './edit-task-form.component.html',
  styleUrls: ['./edit-task-form.component.scss']
})
export class EditTaskFormComponent implements AfterViewInit, OnInit {
  @Input() task: Task.AsObject = new Task().toObject();
  taskStateMappings = TaskStateMappings;

  @ViewChild('taskTitle') taskTitle: ElementRef;
  @ViewChild('taskForm') taskForm: NgForm;
  @Output() statusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.taskTitle.nativeElement.focus();
    this.taskForm.statusChanges?.subscribe(result => this.statusChanged.emit(result === 'VALID'));
  }

  onSubmit() {
    this.formSubmitted.emit(true);
  }
}
